module.exports = __webpack_public_path__ + "img/qa.2d0a5138.svg";